import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../services/loader.service';
import {
  AuthenticationStore,
  ResetPasswordObject,
} from '../stores/authentication.store';
import { LoginPagePage } from '../login-page/login-page.page';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage implements OnInit {
  password_validations: FormGroup;
  validation_errors: any;
  id: number;
  @Input() payloadId: number;
  constructor(
    private FormBuilder: FormBuilder,
    private auth: AuthenticationStore,
    private loaderService: LoaderService,
    private router: Router,
    private translate: TranslateService,
    public platform: Platform,
    public modalCtrl: ModalController
  ) {}

  async savePassword() {
    var data: ResetPasswordObject = {
      id: this.id,
      password: this.password_validations.value.newPassword,
      confirm_password: this.password_validations.value.confirmPassword,
    };
    this.loaderService.showLoading();
    try {
      await this.auth.resetPassword(data);
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        this.translate.instant(
          'ACCOUNT_PAGE.ACCOUNT_SETTING.ACCOUNT_SUB_SECTION.PASSWORD_ADDED'
        ),
        'top',
        'success'
      );
      if (this.platform.is('mobile')) {
        this.router.navigate(['/login-page'], { replaceUrl: true });
      } else {
        this.dissmissModal()
        // desktop login is a full page (was a modal)
        this.router.navigate(['/login-page'], {
          state: {}, // after a password reset, land on the home page
        });
      }
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(error.error.data, 'top', 'danger');
    }
    // this.loaderService.presentToast(response.data)
  }
  ngOnInit() {
    this.ionViewDidEnter();
  }
  ionViewDidEnter() {
    if (this.platform.is('mobile')) {
      if (this.router.getCurrentNavigation()?.extras?.state) {
        this.id = this.router.getCurrentNavigation()?.extras?.state?.id;
      }
    } else {
      this.id = this.payloadId;
    }
    this.getErrors();
    this.password_validations = this.FormBuilder.group({
      newPassword: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      confirmPassword: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });
  }
  getErrors() {
    this.validation_errors = {
      newPassword: [
        {
          type: 'required',
          message: `ACCOUNT_PAGE.ACCOUNT_SETTING.ACCOUNT_SUB_SECTION.INPUT_NEW_PASSWORD`,
        },
      ],
      confirmPassword: [
        {
          type: 'required',
          message: `ACCOUNT_PAGE.ACCOUNT_SETTING.ACCOUNT_SUB_SECTION.INPUT_CONFIRM_PASSWORD`,
        },
      ],
    };
  }

  dissmissModal() {
    this.modalCtrl.dismiss();
  }
}
